// extracted by mini-css-extract-plugin
module.exports = {"PlannedTourAssignment":"PlannedTourAssignment_PlannedTourAssignment__1WZOF"};